export default "__VITE_ASSET__81bc976f__"